module.exports = {
  apiHost: "https://api.madeline.sensoreal.app",
  assetsHost: "https://assets.madeline.sensoreal.app",
  brandName: "Madeline",
  header: {
    text: { en: "Your Madeline Selections" },
    logo:
      "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/Madeline_Logo_Wordmark_Ivy.png",
    // companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#141414",
    textColor: "#fff",
    font: "aeonik",
    backgroundGradient: "linear-gradient(180deg, #383838 0%, #141414 100%)",
  },
  contact: {
    website: "https://sensoreal.io/",
    address: "22 Address Avenue, Suburb",
    phone: "(08) 8130 2777",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/",
    twitter: "",
    instagram: "https://www.instagram.com/",
    facebook: "https://www.facebook.com/",
  },
  footerLogo: "",
};
